import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertTriangle, RefreshCw, WifiOff } from 'lucide-react';
import { cn } from '../utils/cn.js';
import { Button } from './Button.js';
const variantConfig = {
    general: {
        icon: _jsx(AlertTriangle, { className: "h-8 w-8" }),
        title: 'Something went wrong',
        description: 'An unexpected error occurred. Please try again.',
    },
    network: {
        icon: _jsx(WifiOff, { className: "h-8 w-8" }),
        title: 'No connection',
        description: 'Check your network connection and try again.',
    },
    notFound: {
        icon: _jsx(AlertTriangle, { className: "h-8 w-8" }),
        title: 'Not found',
        description: 'The resource you requested could not be found.',
    },
    forbidden: {
        icon: _jsx(AlertTriangle, { className: "h-8 w-8" }),
        title: 'Access denied',
        description: "You don't have permission to view this content.",
    },
};
function ErrorState({ variant = 'general', title, description, onRetry, isRetrying = false, className, }) {
    const config = variantConfig[variant];
    return (_jsxs("div", { className: cn('flex flex-col items-center justify-center text-center py-16 px-6', className), role: "alert", children: [_jsx("div", { className: "mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-status-red-bg text-status-red", children: config.icon }), _jsx("h3", { className: "text-base font-semibold text-content mb-1", children: title ?? config.title }), _jsx("p", { className: "text-sm text-content-subtle max-w-sm mb-6", children: description ?? config.description }), onRetry && (_jsx(Button, { variant: "secondary", size: "sm", onClick: onRetry, loading: isRetrying, leftIcon: _jsx(RefreshCw, { className: "h-4 w-4" }), children: "Try again" }))] }));
}
export { ErrorState };
//# sourceMappingURL=ErrorState.js.map